import React from 'react';
import { CheckCircle2, Frown, Droplets, Bug, Calendar, HelpCircle, Dices, Cloud, FlaskConical, Brain } from 'lucide-react';
import { motion } from 'framer-motion';
const PAIN_POINTS = [{
  text: 'Compraste semillas con ilusión… y no germinaron.',
  icon: Frown
}, {
  text: 'Plantaste algo… y se te secó sin entender por qué.',
  icon: Droplets
}, {
  text: 'Te apareció una plaga… y te arruinó semanas de trabajo.',
  icon: Bug
}, {
  text: 'Te entusiasmás un mes… y después se vuelve un desorden.',
  icon: Calendar
}, {
  text: 'No sabés qué plantar, cuándo, ni cómo sostenerlo todo el año.',
  icon: HelpCircle,
  colSpan: true
}];
const REFRAME_POINTS = [{
  text: 'suerte',
  icon: Dices
}, {
  text: 'clima',
  icon: Cloud
}, {
  text: 'prueba y error',
  icon: FlaskConical
}, {
  text: 'energía mental constante',
  icon: Brain
}];
const PRODUCT_FEATURES = ['empezar desde cero (sin experiencia)', 'organizar tu espacio de forma inteligente', 'producir alimentos todo el año', 'reducir gastos de verdulería', 'y si querés, escalar para vender o emprender'];
export function SalesLetterSection() {
  return <section className="py-16 px-4 bg-black" data-id="element-185">
      <div className="max-w-4xl mx-auto space-y-16" data-id="element-186">
        {/* APERTURA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl mx-auto" data-id="element-187">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-188">
            Si alguna vez intentaste empezar una huerta y te pasó esto…
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-189">
            {PAIN_POINTS.map((item, i) => <div key={i} className={`bg-red-500/5 border border-red-500/10 rounded-xl p-4 flex items-start gap-3 ${item.colSpan ? 'sm:col-span-2' : ''}`} data-id="element-190">
                <div className="bg-red-500/10 p-2 rounded-lg shrink-0" data-id="element-191">
                  <item.icon className="w-5 h-5 text-red-500" data-id="element-192" />
                </div>
                <span className="text-gray-300 text-sm md:text-base leading-snug pt-0.5" data-id="element-193">
                  {item.text}
                </span>
              </div>)}
          </div>

          <p className="text-white font-bold text-lg mb-4 text-center" data-id="element-194">
            Entonces entendés lo más frustrante:
          </p>

          <div className="border-l-4 border-green-500 pl-6 py-5 bg-green-500/5 rounded-r-2xl shadow-lg" data-id="element-195">
            <p className="text-xl md:text-2xl text-white italic font-medium leading-relaxed" data-id="element-196">
              "No es que 'no se te da'. Es que nadie te dio un sistema simple,
              claro y ordenado."
            </p>
          </div>
        </motion.div>

        <div className="h-px w-full bg-gradient-to-r from-transparent via-zinc-800 to-transparent" data-id="element-197" />

        {/* REENCUADRE */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl mx-auto text-center" data-id="element-198">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-199">
            El problema no sos vos. Ni tu patio. Ni tu balcón. Ni tu tiempo.
          </h2>
          <p className="text-gray-400 text-lg mb-8" data-id="element-200">
            El problema es que te enseñaron "tips sueltos" en vez de un sistema.
            Y sin sistema, la huerta depende de:
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-201">
            {REFRAME_POINTS.map((item, i) => <div key={i} className="flex items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-full px-5 py-2.5" data-id="element-202">
                <item.icon className="w-4 h-4 text-zinc-400" data-id="element-203" />
                <span className="text-gray-300 font-medium" data-id="element-204">{item.text}</span>
              </div>)}
          </div>

          <p className="text-white font-bold text-xl bg-zinc-900/50 inline-block px-6 py-2 rounded-lg border border-zinc-800" data-id="element-205">
            Eso no es sostenible.
          </p>
        </motion.div>

        <div className="h-px w-full bg-gradient-to-r from-transparent via-zinc-800 to-transparent" data-id="element-206" />

        {/* PRESENTACIÓN DEL PRODUCTO */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-207">
          <div className="text-center mb-10" data-id="element-208">
            <p className="text-gray-400 text-lg mb-2" data-id="element-209">Por eso existe:</p>
            <h2 className="text-4xl md:text-5xl font-black text-green-500 mb-2 tracking-tight" data-id="element-210">
              HUERTA PRODUCTIVA 360°
            </h2>
            <p className="text-xl text-white font-semibold" data-id="element-211">
              Sistema Integral desde Cero
            </p>
          </div>

          <div className="max-w-2xl mx-auto" data-id="element-212">
            <p className="text-gray-300 text-lg mb-6" data-id="element-213">
              Un pack digital diseñado para que puedas:
            </p>
            <div className="flex flex-col gap-3" data-id="element-214">
              {PRODUCT_FEATURES.map((item, i) => <div key={i} className="flex items-center gap-3 bg-green-500/5 border border-green-500/10 rounded-lg px-4 py-3" data-id="element-215">
                  <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-216" />
                  <span className="text-gray-200 font-medium" data-id="element-217">{item}</span>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}